import { useNavigate } from "react-router";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { PaginationParams, SourceResource } from "@prequel/import-react";
import { useImportContext } from "@prequel/import-react";

import { importClient } from "./sdk/client";

import { useAllPages } from "@/api/pagination";
import { useToast } from "@/providers/ToastProvider";

export type { SourceResource } from "@prequel/import-react";

const routes = {
  delete: (id: string) => `/import/sources/${id}`,
};

const keys = { all: ["import", "sources"] as const };

export function useAllSources(providerId?: string, options?: { enabled?: boolean }) {
  const { sources } = useImportContext();

  return useAllPages<SourceResource>(
    [...keys.all, providerId ?? ""],
    (params: PaginationParams) => sources.list({ ...params, provider_id: providerId }),
    options,
  );
}

export function useDeleteSource() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { addToast } = useToast();

  return useMutation({
    mutationFn: (id: string) => importClient.delete(routes.delete(id)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.all });
      addToast({ kind: "SUCCESS", message: "Source deleted successfully!" });
      navigate("/import/sources");
    },
    // no onError: QueryProvider's mutationCache raises the error toast globally
  });
}
